export const guidePages = [
  {
    path: "/bursa-masaj",
    crumb: "Bursa Masaj Rehberi",
    title: "Bursa Masaj | Masaj Türleri ve Rehberi | Lavenza",
    description: "Bursa masaj rehberi: klasik, medikal, soft masaj ve kese köpük arasındaki farklar, kime uygun olduğu ve doğru seçim ipuçları. Lavenza Nilüfer'den yönlendirme.",
    eyebrow: "Rehber · Masaj Türleri",
    accent: "Bursa Masaj Rehberi:",
    h1: "Türler, Faydalar ve Doğru Seçim",
    image: "/images/bursa-masaj-rehberi.webp",
    imageAlt: "Masaj yağları, lavanta ve havlular",
    intro: "Bursa'da masaj yaptırmak istiyorsunuz ama hangi türün size uygun olduğundan emin değilsiniz. Bu rehberde dört temel uygulamayı sade bir dille anlatıyor, kimin neyi neden tercih ettiğini örneklerle açıklıyor ve seçim yaparken sorabileceğiniz soruları paylaşıyoruz.",
    sections: [
      {
        h2: "Masaj Türleri Arasındaki Temel Farklar",
        paragraphs: [
          "Masaj türlerini ayıran üç değişken vardır: baskının şiddeti, hareketin hızı ve hedeflenen bölge. Klasik masaj orta baskı ve akıcı hareketlerle tüm vücuda uygulanır. Medikal masaj baskıyı belirli kas gruplarına yoğunlaştırır ve daha yavaş çalışır. Soft masaj düşük baskı ve sakin bir ritimle ilerler. Kese ve köpük ise kaslardan çok cilde yöneliktir; arındırma ve ferahlama sağlar.",
          "Bursa masaj arayışında bu farkları bilmek, beklentinizle uygulamayı eşleştirmenizi kolaylaştırır. Yanlış tür seçmek zarar vermez ama istediğiniz sonucu almanızı geciktirebilir.",
        ],
      },
      {
        h2: "Klasik Masaj Kimler İçin?",
        paragraphs: [
          "Haftanın yorgunluğunu atmak, uyku düzenini toparlamak ve genel bir hafiflik hissi isteyen kişiler için en dengeli seçenektir. Belirli bir şikâyetiniz yoksa ve sadece \"kendimi iyi hissetmek istiyorum\" diyorsanız klasik masajla başlamak mantıklıdır. Baskı seviyesi seans içinde konuşarak ayarlanır.",
        ],
      },
      {
        h2: "Medikal Masaj Ne Zaman Düşünülür?",
        paragraphs: [
          "Boyun, omuz, sırt veya belde uzun süredir devam eden bir yoğunluk hissediyorsanız, uygulamanın o bölgeye odaklanması daha faydalı olabilir. Medikal masaj bu ihtiyaç için tasarlanmıştır. Önemli not: masaj tıbbi bir tedavi değildir; devam eden bir ağrınız varsa önce hekiminize danışmanızı öneririz. Masaj, hekim onayıyla birlikte rahatlamaya destek olabilir.",
        ],
      },
      {
        h2: "Soft Masaj ve Kese & Köpük: Hafiflik ve Arınma",
        paragraphs: [
          "Soft masaj, güçlü baskıdan hoşlanmayan, hassas cildi olan ya da tamamen zihinsel bir dinginlik arayanlar için idealdir. Kese ve köpük ise bir masaj türü değil, hamam geleneğinden gelen bir bakım ritüelidir: kese ile ölü hücreler alınır, ardından bol köpükle yıkama yapılır. İki uygulamanın arka arkaya alınması, Bursa'da spa deneyimi arayanlar için sık tercih edilen bir kombinasyondur.",
        ],
        list: [
          "Genel yorgunluk → Klasik masaj",
          "Bölgesel sertlik → Medikal masaj",
          "Hafif dokunuş isteği → Soft masaj",
          "Cilt yenilenmesi ve ferahlık → Kese & köpük",
        ],
      },
      {
        h2: "Seçim Yaparken Sorabileceğiniz Sorular",
        paragraphs: [
          "Randevu almadan önce kendinize şunları sorun: Şikâyetim belli bir bölgede mi, genel mi? Güçlü baskıyı sever miyim? Seans sonrası hemen işe dönecek miyim, yoksa dinlenme vaktim var mı? Bu üç sorunun yanıtı, uygulamayı büyük ölçüde belirler. Emin olamadığınız noktaları WhatsApp'tan yazabilirsiniz; Lavenza ekibi kısa bir görüşmeyle sizi yönlendirir.",
        ],
      },
      {
        h2: "Bursa'da Masaj İçin Lavenza",
        paragraphs: [
          "Bu rehberde anlatılan dört uygulamanın tamamı Nilüfer Konak Mahallesi'ndeki salonumuzda sunulmaktadır. Salonumuzu ve ulaşım seçeneklerini Bursa masaj salonu sayfamızda, uygulamaların ayrıntılarını ise ilgili hizmet sayfalarında bulabilirsiniz.",
        ],
      },
      {
        h2: "Masaj Öncesi ve Sonrası İçin Pratik Öneriler",
        paragraphs: [
          "Hangi türü seçerseniz seçin, birkaç küçük alışkanlık deneyimi belirgin şekilde iyileştirir. Seans öncesinde kafein ve ağır yemeklerden uzak durmak, bedenin gevşemesini kolaylaştırır. Gün içinde yeterince su içmiş olmak kasların daha yumuşak tepki vermesini sağlar. Sonrasında ise acele etmemek en önemlisi: masadan yavaş kalkın, birkaç dakika oturun, bol su için.",
          "Aynı gün yoğun spor yapmamak, mümkünse erken uyumak ve ertesi sabah hafif bir esneme ile başlamak etkiyi uzatır. Kaslarda hissedilen hafif hassasiyet çoğunlukla bir günde geçer. Bu önerilerin hiçbiri kural değil; ama uygulayanlar farkı hissediyor.",
        ],
        list: [
          "Öncesinde: hafif yemek, kafeinsiz, bol su",
          "Sonrasında: yavaş kalkış, dinlenme, erken uyku",
          "Ertesi gün: hafif esneme, ağır spordan kaçınma",
        ],
      },
    ],
    related: [
      { label: "Bursa Masaj Salonu", path: "/bursa-masaj-salonu" },
      { label: "Klasik Masaj Bursa", path: "/bursa-klasik-masaj" },
      { label: "Medikal Masaj Bursa", path: "/bursa-medikal-masaj" },
      { label: "Soft Masaj Bursa", path: "/bursa-soft-masaj" },
      { label: "Nilüfer'de Masaj Seçimi", path: "/nilufer-masaj" },
    ],
    faq: [
      { q: "Masaj türleri arasında en çok tercih edilen hangisi?", a: "Genel rahatlama amacıyla en sık klasik masaj tercih edilir. Bölgesel yoğunluk yaşayanlar ise medikal masaja yöneliyor." },
      { q: "İki masaj türünü aynı seansta birleştirmek mümkün mü?", a: "Evet. Örneğin kese köpükten sonra soft ya da klasik masaj alınabilir. Kombinasyon için WhatsApp'tan bilgi isteyin." },
      { q: "Masaj ağrıyı tedavi eder mi?", a: "Masaj tıbbi tedavi yerine geçmez. Kas gerginliğini hafifletmeye yardımcı olabilir; süregelen bir şikâyetiniz varsa hekiminize danışmanızı öneririz." },
      { q: "Ne sıklıkla masaj yaptırmak uygundur?", a: "Kişiden kişiye değişir. Birçok misafirimiz ayda bir ya da iki kez tercih ediyor; ihtiyacınıza göre birlikte plan yapabiliriz." },
      { q: "Seans için nasıl giyinmeliyim?", a: "Rahat kıyafetle gelmeniz yeterli; bornoz ve havlu salonda sağlanır. Takı ve saat gibi aksesuarları çıkarmanız önerilir." },
    ],
  },
  {
    path: "/nilufer-masaj",
    crumb: "Nilüfer Masaj Seçim Rehberi",
    title: "Nilüfer Masaj | Hangi Masaj Size Uygun? | Lavenza",
    description: "Nilüfer'de masaj seçimi: yaşam tarzınıza, şikâyetinize ve beklentinize göre hangi masaj size uygun? Ofis çalışanı, sporcu, yeni başlayan için pratik öneriler.",
    eyebrow: "Rehber · Doğru Seçim",
    accent: "Nilüfer'de Masaj:",
    h1: "Size Uygun Masajı Seçme Rehberi",
    image: "/images/nilufer-masaj-rehberi.webp",
    imageAlt: "Beyaz çarşaflı masaj masası ve yeşil örtü",
    intro: "Nilüfer'de yaşayan ya da çalışan biri olarak masaj yaptırmaya karar verdiniz; peki hangisini? Bu sayfa, yaşam tarzınızı ve gününüzü nasıl geçirdiğinizi merkeze alarak seçim yapmanıza yardımcı olur. Uygulama tanımları yerine somut senaryolar üzerinden gidiyoruz.",
    sections: [
      {
        h2: "Gününüz Nasıl Geçiyor? Seçimin İlk Adımı",
        paragraphs: [
          "Nilüfer'de günlük hayat oldukça çeşitli: kampüste ders veren akademisyenler, plazalarda çalışan beyaz yakalılar, mağazalarda ayakta duran çalışanlar, evde çocuk büyüten ebeveynler. Her birinin bedeni farklı yorulur. Gün boyu oturan biri boyun ve belde, ayakta çalışan biri bacak ve ayakta, zihinsel yoğunluk yaşayan biri ise omuzlarda gerginlik biriktirir. Nilüfer masaj seçiminde ilk adım, bu birikimin nerede olduğunu fark etmektir.",
        ],
      },
      {
        h2: "Masa Başı Çalışanlar İçin",
        paragraphs: [
          "Ekran karşısında geçen uzun saatler boyun ve üst sırtta sertlik yaratır. Bu profildeki misafirlerimiz çoğunlukla medikal masajdan memnun kalıyor; uygulama üst sırt ve boyun bölgesine yoğunlaşır. Haftalık tempo çok yoğunsa ilk seansı klasik masajla başlatıp sonraki seanslarda bölgesel çalışmaya geçmek de iyi bir strateji.",
        ],
      },
      {
        h2: "Aktif Yaşayanlar ve Spor Yapanlar İçin",
        paragraphs: [
          "Düzenli koşan, ağırlık çalışan ya da yoğun tempolu spor yapanların kasları farklı bir dinlenmeye ihtiyaç duyar. Antrenman sonrası klasik masaj kasların gevşemesine yardımcı olabilir; belirli bir kas grubunda sürekli yoğunluk varsa medikal masaj tercih edilebilir. Yarış ya da müsabaka öncesi güçlü baskılı uygulamalardan kaçınmak, bunun yerine soft masajla gevşemek genel bir öneridir.",
        ],
      },
      {
        h2: "İlk Kez Gelecekler ve Hassas Bünyeler İçin",
        paragraphs: [
          "Daha önce hiç masaj yaptırmadıysanız, ne bekleyeceğinizi bilmemek doğal. Bu durumda soft masaj güvenli bir başlangıçtır: düşük baskı, yavaş tempo, hiçbir sürpriz yok. Cildi hassas olan, kolay morarabilen ya da güçlü dokunuştan rahatsız olan misafirlerimiz de bu uygulamayı seçiyor. Seans sırasında her an \"daha hafif\" ya da \"biraz daha güçlü\" diyebilirsiniz.",
        ],
        list: [
          "Boyun ve üst sırt yoğunluğu → Medikal masaj",
          "Antrenman sonrası genel gevşeme → Klasik masaj",
          "İlk deneyim veya hassas cilt → Soft masaj",
          "Cilt bakımı ve ferahlık → Kese & köpük eklentisi",
        ],
      },
      {
        h2: "Kararsız Kaldığınızda",
        paragraphs: [
          "Tek bir uygulama seçmek zorunda değilsiniz. Birçok misafirimiz farklı seanslarda farklı türleri deneyip kendine en uygun olanı bulur. Randevu alırken WhatsApp'tan iki cümleyle durumunuzu anlatmanız yeterli; ekibimiz uygulamayı önerir, seans başında yeniden konuşulur ve gerekirse değiştirilir. Nilüfer masaj salonu sayfamızda ilçe içi ulaşım bilgilerini bulabilirsiniz.",
          "Unutmayın: doğru masaj, en popüler olan değil, o gün bedeninizin gerçekten ihtiyaç duyduğu olandır. Bu ihtiyaç haftadan haftaya değişebilir; bugün soft, gelecek ay medikal isteyebilirsiniz. Esnek kalmak, seçimi kolaylaştırır.",
        ],
      },
      {
        h2: "Sık Yapılan Seçim Hataları",
        paragraphs: [
          "En yaygın hata, \"ne kadar sert o kadar iyi\" düşüncesidir. Güçlü baskı her zaman daha etkili değildir; bedeniniz direnç gösteriyorsa kaslar gevşemez, tam tersine kasılır. İkinci hata, bir arkadaşınızın memnun kaldığı uygulamayı kendi ihtiyacınızı düşünmeden seçmektir; onun boyun ağrısı için iyi gelen medikal çalışma, sizin genel yorgunluğunuz için gereksiz olabilir.",
          "Üçüncü hata ise seansta hissettiklerinizi söylememek. Uygulayıcı sizin bedeninizi sizden iyi bilemez; \"burası hassas\" ya da \"biraz daha yavaş\" demek deneyimi anında düzeltir. Son olarak, tek seansla mucize beklemek hayal kırıklığı yaratır; düzen ve tutarlılık çoğu zaman şiddetten daha değerlidir.",
        ],
      },
    ],
    related: [
      { label: "Nilüfer Masaj Salonu", path: "/nilufer-masaj-salonu" },
      { label: "Bursa Masaj Rehberi", path: "/bursa-masaj" },
      { label: "Medikal Masaj Bursa", path: "/bursa-medikal-masaj" },
      { label: "Soft Masaj Bursa", path: "/bursa-soft-masaj" },
      { label: "Nilüfer Spa Merkezi", path: "/nilufer-spa" },
    ],
    faq: [
      { q: "Ofiste çalışıyorum, boynum sürekli tutuk; hangi masaj?", a: "Bu şikâyette genellikle boyun ve üst sırta odaklanan medikal masaj tercih edilir. Süregelen bir durumsa hekim görüşü almanızı da öneririz." },
      { q: "Spor sonrası hemen masaj yaptırabilir miyim?", a: "Hafif tempolu antrenman sonrası klasik ya da soft masaj alınabilir. Çok yoğun bir antrenmanın hemen ardından birkaç saat beklemeniz daha rahat olur." },
      { q: "Hamileyken masaj yaptırılır mı?", a: "Bu konuda mutlaka hekiminize danışmanız gerekir. Onay olmadan uygulama yapmıyoruz; onay varsa uygun pozisyon ve baskıyla planlarız." },
      { q: "Seans sırasında uygulamayı değiştirebilir miyim?", a: "Evet. Baskı, tempo ve odaklanılan bölge seans içinde konuşularak ayarlanır; rahat etmediğiniz bir şeyi söylemekten çekinmeyin. Klasikten softa geçmek ya da tek bir bölgeye yoğunlaşmak dakikalar içinde mümkündür. Uygulayıcı için bu bir zorluk değil, işin doğal parçasıdır." },
      { q: "Nilüfer'de akşam geç saatte masaj bulabilir miyim?", a: "Lavenza gece 04:00'e kadar açık; iş çıkışı ya da geç saat randevuları için WhatsApp'tan yazmanız yeterli." },
    ],
  },
  {
    path: "/konak-masaj",
    crumb: "Konak'ta İlk Seans Rehberi",
    title: "Konak Masaj | Konak Mahallesi'nde Masaj Deneyimi | Lavenza",
    description: "İlk kez masaja gidecekler için Konak Mahallesi rehberi: randevu öncesi hazırlık, seansta neler olur, sonrasında nelere dikkat edilir. Lavenza Nilüfer'den öneriler.",
    eyebrow: "Rehber · İlk Seans",
    accent: "Konak Mahallesi'nde Masaj:",
    h1: "İlk Seans Rehberi",
    image: "/images/konak-masaj-ilk-seans.webp",
    imageAlt: "Bornoz, terlik ve limonlu su ile hazırlık alanı",
    intro: "İlk masaj randevunuz yaklaşıyor ve kafanızda sorular var: ne giyilir, ne zaman gelinir, seansta ne olur, sonrasında ne yapılır? Konak Mahallesi'ndeki salonumuza ilk kez gelecek misafirlerimiz için bu rehberi hazırladık. Endişe edecek hiçbir şey yok; sadece bilmek iyi gelir.",
    sections: [
      {
        h2: "Randevudan Önce: Küçük Hazırlıklar",
        paragraphs: [
          "Seans günü ağır bir öğün yememeye çalışın; hafif bir şeyler yiyip bol su içmek en iyisidir. Alkol almamanız önemli. Duş alıp gelmeniz hem sizin hem de uygulamanın rahatlığı için idealdir. Kolay çıkarılabilen rahat kıyafetler tercih edin; takı, saat ve gözlük gibi eşyalarınızı odada güvenle bırakabilirsiniz. Randevunuzdan beş dakika önce Konak Mahallesi'ndeki salonumuzda olmanız yeterli.",
        ],
      },
      {
        h2: "Kapıdan Girince: Karşılama ve Kısa Görüşme",
        paragraphs: [
          "Sizi karşılar, ayakkabılarınızı çıkarmanızı rica eder ve odanıza alırız. Seansa başlamadan önce birkaç soru sorarız: daha önce masaj yaptırdınız mı, vücudunuzda hassas ya da ağrılı bir bölge var mı, ne kadar baskı istersiniz? Bu görüşme iki üç dakika sürer ama uygulamanın kalitesini belirler. Bir sağlık durumunuz veya yakın zamanda geçirdiğiniz bir sakatlık varsa mutlaka paylaşın.",
        ],
      },
      {
        h2: "Seans Sırasında Neler Olur?",
        paragraphs: [
          "Odada yalnız kalıp hazırlanmanız için size süre verilir; havlu ile örtünüp masaya uzanırsınız. Uygulama boyunca yalnızca çalışılan bölge açıkta kalır. Işık loş, müzik düşük sesli olur. Konuşmak zorunda değilsiniz; birçok misafirimiz gözlerini kapatıp dinlenmeyi tercih eder. Baskı fazla ya da az geliyorsa söylemeniz yeterli; bu bir eleştiri değil, doğru uygulamanın parçasıdır. Konak masaj deneyiminiz tamamen sizin ritminizde ilerler.",
        ],
        list: [
          "Hazırlanmanız için oda size bırakılır",
          "Yalnızca çalışılan bölge açıkta kalır",
          "Baskı ve tempo istediğiniz an değiştirilir",
          "Konuşmak ya da sessiz kalmak sizin tercihiniz",
        ],
      },
      {
        h2: "Seans Sonrası: Acele Etmeyin",
        paragraphs: [
          "Masaj bittiğinde hemen ayağa kalkmayın; birkaç dakika masada kalıp yavaşça doğrulun. Ardından odada giyinmeniz için zaman tanınır. Seans sonrası bol su içmek ve o gün ağır fiziksel aktiviteden kaçınmak iyi gelir. Bazı kişilerde hafif bir yorgunluk ya da uyku isteği görülebilir; bu normaldir. Kaslarda birkaç saat süren hafif hassasiyet de olabilir.",
        ],
      },
      {
        h2: "İlk Seans İçin Hangi Uygulama?",
        paragraphs: [
          "İlk deneyim için soft ya da klasik masaj öneririz. Kese ve köpük eklemek isterseniz, önce arınma ritüeli sonra masaj sırası izlenir. Medikal masajı ise belirli bir şikâyetiniz varsa ve hekiminiz masaja onay verdiyse düşünmeniz daha uygundur.",
        ],
      },
      {
        h2: "Konak Mahallesi'nde Lavenza'ya Gelmek",
        paragraphs: [
          "Salonumuz Kurşunlu Sokak üzerinde, mahallenin içinde. Konak masaj salonu sayfamızda ulaşım ve park bilgilerini, iletişim sayfamızda ise harita ve yol tarifini bulabilirsiniz. İlk randevunuz için WhatsApp'tan \"ilk kez geliyorum\" yazmanız yeterli; gerisini birlikte planlarız.",
          "İlk seansa gelen misafirlerimize biraz daha fazla zaman ayırırız: salonu tanımanız, soru sormanız ve acele hissetmemeniz için. Bu yüzden ilk randevunuzu mümkünse sıkışık bir programın ortasına değil, sonrasında dinlenebileceğiniz bir saate koymanızı öneririz.",
        ],
      },
      {
        h2: "İlk Seanstan Sonra: Devam Etmeli Miyim?",
        paragraphs: [
          "İlk seans bir tanışmadır; bedeninizin nasıl tepki verdiğini, hangi bölgelerin daha çok ilgi istediğini ve size uygun baskıyı o gün öğrenirsiniz. Ertesi gün kendinizi nasıl hissettiğinize dikkat edin: daha rahat uyudunuz mu, omuzlarınız daha aşağıda mı, ruh haliniz nasıl? Bu gözlemler ikinci seansın planını belirler.",
          "Devam kararı tamamen sizin. Bazı misafirlerimiz yılda birkaç kez, bazıları her ay geliyor. Önemli olan sıklık değil, kendinize ayırdığınız bu vaktin gerçekten işe yaramasıdır. İkinci randevunuzda ilk seansta neyi sevdiğinizi ve neyin değişmesini istediğinizi söylemeniz, deneyimi her seferinde biraz daha size ait kılar.",
        ],
        list: [
          "Ertesi gün uyku ve gerginlik düzeyinizi gözlemleyin",
          "İkinci seansta geri bildirimlerinizi paylaşın",
          "Sıklığı bedeninizin ihtiyacına göre belirleyin",
        ],
      },
    ],
    related: [
      { label: "Konak Masaj Salonu", path: "/konak-masaj-salonu" },
      { label: "Soft Masaj Bursa", path: "/bursa-soft-masaj" },
      { label: "Klasik Masaj Bursa", path: "/bursa-klasik-masaj" },
      { label: "Nilüfer'de Masaj Seçimi", path: "/nilufer-masaj" },
      { label: "İletişim & Randevu", path: "/iletisim" },
    ],
    faq: [
      { q: "İlk masaj seansımda utanmam gerekir mi?", a: "Hayır. Hazırlanırken oda size bırakılır ve uygulama boyunca yalnızca çalışılan bölge açıkta kalır. Konforunuz her adımda önceliktir." },
      { q: "Seans öncesi yemek yiyebilir miyim?", a: "Hafif bir şeyler yiyebilirsiniz; ağır öğünlerden ve alkolden kaçınmanızı öneririz." },
      { q: "Masaj sonrası duş almam gerekir mi?", a: "Zorunlu değil. Yağ kullanılan uygulamalardan sonra isterseniz evinizde duş alabilirsiniz; salonda temizlenmeniz için havlu sağlanır." },
      { q: "İlk seansta acı hissedilir mi?", a: "Soft ve klasik masajda acı beklenmez. Baskı size fazla gelirse söylemeniz yeterli, anında hafifletilir." },
      { q: "Yanımda birini getirebilir miyim?", a: "Bekleme alanımız sınırlı olduğu için refakatçi konusunu randevu alırken WhatsApp'tan belirtmenizi rica ederiz." },
    ],
  },
];
